import Service from '@ember/service';

export interface ExpiringMemoryCacheFetchArgs {
  key: string;
  expiresInMinutes: number;
  // called when the key isn't cached and should return the value to be cached
  loadValue: () => Promise<any>;
}

interface CacheItem {
  valuePromise: Promise<any>;
  expiresAt: Date;
}

export interface ExpiringMemoryCacheFetchResult<T> {
  value: T;
  fromCache: boolean;
}

export default class ExpiringMemoryCache extends Service {
  cache: { [key: string]: CacheItem } = {};

  fetch<T>(
    args: ExpiringMemoryCacheFetchArgs,
  ): Promise<ExpiringMemoryCacheFetchResult<T>> {
    let cacheItem = this.cache[args.key];
    if (cacheItem && cacheItem.expiresAt > new Date()) {
      return cacheItem.valuePromise.then((value) => {
        return Promise.resolve({ value, fromCache: true });
      });
    }

    cacheItem = this.cache[args.key] = {
      expiresAt: new Date(new Date().getTime() + args.expiresInMinutes * 60000),
      valuePromise: args.loadValue(),
    };
    return cacheItem.valuePromise.then((value) => {
      return Promise.resolve({ value, fromCache: false });
    });
  }

  remove(key: string) {
    delete this.cache[key];
  }

  removeAll() {
    this.cache = {};
  }
}
